window.addEventListener("load", () => {
  let isClicked = false;
  const notifyMeBtn = document.querySelector(".BIS_trigger");
  notifyMeBtn.addEventListener("click", () => {
    if (isClicked == false) {
      setTimeout(() => {
        notifyMeBtn.click();
      }, 1000);
    }
    isClicked = true;
  });
});
